import styled from 'styled-components';
import { colors } from 'app/variables';

export const Dropdown = styled.div`
  display: inline-flex;
  position: relative;
  vertical-align: top;
  width: 100%;
  padding: 1.6rem 0rem 0.6rem 0;
  margin-bottom: auto;
`;
export const DropdownContent = styled.div.attrs(() => ({
  role: 'listbox',
}))`
  background-color: ${colors.white};
  border-radius: 4px;
  box-shadow:
    0 2px 3px rgba(10, 10, 10, 0.1),
    0 0 0 1px rgba(10, 10, 10, 0.1);
  max-height: 190px;
  width: 9rem;
  overflow-y: auto;
  overflow-x: hidden;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
`;
export const DropdownItem = styled.div.attrs(() => ({
  tabIndex: 0,
  role: 'option',
}))`
  cursor: pointer;
  padding-right: 3rem;
  text-align: left;
  white-space: nowrap;
  width: auto;
  display: block;
  line-height: 1.5;
  padding: 0.375rem 1rem;
  position: relative;
  background-color: ${(props) => (props.active ? colors.pacificBlue : 'unset')};
  color: ${(props) => (props.active ? colors.white : 'inherit')};
  &:hover {
    ${(props) =>
      props.active
        ? ''
        : `
      background-color: ${colors.whiteSand};
    `}
  }
  &:focus {
    outline: none;
    box-shadow: inset 0px 0px 1px 1px ${colors.pacificBlue};
    color: ${colors.pacificBlue};
    background-color: unset;
  }
`;
export const DropdownMenu = styled.div`
  padding-top: 0;
  left: 1px;
  position: absolute;
  top: 100%;
  z-index: 20;
`;
export const DropdownSelect = styled.div.attrs(() => ({
  tabIndex: 0,
  role: 'button',
}))`
  position: relative;
  width: 100%;
  cursor: pointer;
  padding: 0 2rem 0.85rem 0.3rem;
  border-bottom: ${(props) =>
    props.active
      ? `1px solid ${colors.pacificBlue}`
      : `1px solid ${colors.alto}`};
  white-space: nowrap;
  &::after {
    border: 2px solid
      ${(props) => (props.active ? colors.pacificBlue : 'currentColor')};
    border-right: 0;
    border-top: 0;
    content: ' ';
    display: block;
    height: 10px;
    margin-top: -10px;
    pointer-events: none;
    position: absolute;
    top: 50%;
    right: 5px;
    transform: rotate(-45deg);
    transform-origin: center;
    width: 10px;
  }
  &:hover,
  &:focus {
    outline: none;
    border-color: ${colors.pacificBlue};
    &::after {
      border-color: ${colors.pacificBlue};
    }
  }
`;
